
import { Vue, Component, Prop, Model } from 'nuxt-property-decorator';
import { InputCheckbox } from 'fourwaves-shared/components';
import { AddOnOption, AddOnType, OrganizationCurrency } from 'fourwaves-shared';
import MoneyInput from '~/components/form/MoneyInput.vue';
import { featureListByAddOnType } from '~/services/featureMapping';
import { TranslateResult } from 'vue-i18n';

@Component({
  components: {
    InputCheckbox,
    MoneyInput,
  },
})
export default class CheckoutAddOnCheckboxGroup extends Vue {
  @Prop({ type: Object, required: true }) readonly options!: Record<string, AddOnOption>;
  @Prop({ type: String, default: 'USD' }) readonly currency!: OrganizationCurrency;
  @Prop(Boolean) readonly customPlanMode!: boolean;
  @Prop(Boolean) readonly renew!: boolean;

  @Model('change', { type: Array, default: () => [] }) readonly value!: string[];

  get currencySymbol(): string {
    return this.currency === 'EUR' ? '€' : '$';
  }

  get innerValue(): string[] {
    return this.value;
  }

  set innerValue(value: string[]) {
    this.$emit('change', value);
  }

  public isAddOnDisabled(option: AddOnOption) {
    return this.renew ? option.disabled : option.isActiveForOrganization || option.disabled;
  }

  public getOptionModifier(option: AddOnOption): Record<string, boolean> {
    return {
      '-checked': this.value.includes(option.id),
      '-disabled': this.isAddOnDisabled(option),
    };
  }

  public getFormattedCost(option: AddOnOption): string {
    return `${this.currencySymbol}${option.cost.toLocaleString()} ${this.$t('checkout.add_ons.per_event')}`;
  }

  public getExternalLink(type: AddOnType): TranslateResult {
    return this.$t(`plans.addon_link.${type}`);
  }

  public getFeatureList(type: AddOnType): string[] {
    return featureListByAddOnType[type];
  }

  public onCostChange(optionId: string, cost: number) {
    const updatedOption = { ...this.options[optionId], cost };
    this.$emit('update:options', { ...this.options, [optionId]: updatedOption });
  }
}
